"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModularNavigationWidget = void 0;
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var constants_1 = require("../constants");
var hooks_1 = require("../hooks");
var module_panel_1 = require("./module-panel");
var navigation_icon_1 = require("./navigation-icon");
/**
 *  Хук, отвечающий за открытие всплывающего окна
 *  @returns {} { anchorEl, setPopoverClose, setPopoverOpen, isOpen }
 *  - anchorEl - корневой элемент, при нажатии на который произошло открытие окна
 *  - setPopoverClose - функция закрытия окна
 *  - setPopoverClose - функция открытия окна
 *  - isOpen - состояние окна (true если открыто, false если закрыто)
 */
var ModularNavigationWidget = function (props) {
    var _a = props.locale, locale = _a === void 0 ? constants_1.defaultLocale : _a, loadModulesList = props.loadModulesList, _b = props.modules, outerModules = _b === void 0 ? [] : _b;
    var _c = (0, hooks_1.usePopover)(), anchorEl = _c.anchorEl, setPopoverClose = _c.setPopoverClose, setPopoverOpen = _c.setPopoverOpen, isOpen = _c.isOpen;
    var _d = (0, react_1.useState)([]), modules = _d[0], setModules = _d[1];
    (0, react_1.useEffect)(function () {
        if (loadModulesList) {
            loadModulesList().then(setModules);
        }
    }, [loadModulesList, locale]);
    var resultModules = loadModulesList ? modules : outerModules;
    return (react_1.default.createElement(material_1.StyledEngineProvider, { injectFirst: true }, !!resultModules.length && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(navigation_icon_1.NavigationIcon, { setPopoverOpen: setPopoverOpen }),
        react_1.default.createElement(module_panel_1.ModulePanel, { setPopoverClose: setPopoverClose, anchorEl: anchorEl, isOpen: isOpen, modules: resultModules })))));
};
exports.ModularNavigationWidget = ModularNavigationWidget;
